/* MUI */
import { Typography } from '@mui/material';

/* Shared */
import { Currency } from 'application/Shared/Components/Text';
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';

export const CurrencyValue = ({ textColor, value }) => (
    <Typography
        data-testid="reportsCurrencyValue"
        variant="p"
        sx={{
            color: textColor,
            fontSize: FontSizes[4],
            fontWeight: 600,
            textTransform: 'uppercase'
        }}
    >
        <Currency currency={value} />
    </Typography>
);
